import { render, staticRenderFns } from "./UIGroup.vue?vue&type=template&id=7ac8df6a&scoped=true&"
import script from "./UIGroup.vue?vue&type=script&lang=js&"
export * from "./UIGroup.vue?vue&type=script&lang=js&"
import style0 from "./UIGroup.vue?vue&type=style&index=0&id=7ac8df6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8df6a",
  null
  
)

export default component.exports